// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"21":"75ec5376","555":"ea0a5a44","983":"e1fe9911"}[chunkId] + ".chunk.js";
};